import '.bs{position:relative;}.ssr-plugin'
import '.i3{width:64px;}.ssr-plugin'
import '.i4{height:64px;}.ssr-plugin'
import '.bn{flex-shrink:0;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.i5{bottom:-4px;}.ssr-plugin'
import '.ch{right:-4px;}.ssr-plugin'
import '.dh{border-radius:50%;}.ssr-plugin'
import '.i6{border:2px solid var(--shades-white);}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.i7{width:32px;}.ssr-plugin'
import '.i8{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bs i3 i4 bn"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="l i5 ch dh i6 p i7 i8"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
